module.exports = ($uibModal, $templateCache, $q) ->
  scope:
    metadata: "=metadata"
    metadataTitle: "@metadataTitle"
    metadataSize: "@metadataSize"
  link: ($scope, element, attr) ->
    openMetadataModal = (metadata) ->
      $uibModal.open
        template: require("./metadata-modal.html")
        controller: "MetadataModalController"
        size: $scope.metadataSize or "md"
        resolve:
          title: ->
            $scope.metadataTitle
          metadata: ->
            metadata


    element.on "click", (e) ->
      e.preventDefault()

      if typeof $scope.metadata is "function"
        # metadata can be a function that returns either the metadata as on object or a promise
        $q.when($scope.metadata()).then((metadata) ->
          openMetadataModal(metadata)
        )
      else
        openMetadataModal($scope.metadata)

